import { Component, OnInit } from '@angular/core';
import {
  ColDef,
  GetContextMenuItemsParams,
  GridReadyEvent,
  IServerSideGetRowsParams,
  RowClassRules, RowNode
} from 'ag-grid-community';
import { SharedService } from 'src/app/services/shared.service';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {GridService} from '../../services/grid.service';
import {LocalStorageService} from '../../services/local-storage.service';
import {AuthService} from '../../services/auth.service';
import {HttpService} from '../../services/http.service';

@Component({
  selector: 'app-grid-duplicates',
  templateUrl: './grid-duplicates.component.html',
  styleUrls: ['./grid-duplicates.component.scss']
})
export class GridDuplicatesComponent implements OnInit {
  public readonly rowModelType = 'serverSide';
  public readonly paginationPageSize = 10000;
  public readonly cacheBlockSize = 50;
  public readonly maxBlocksInCache = this.cacheBlockSize / 2;
  public readonly maxConcurrentDatasourceRequests = 1;
  public readonly rowGroupPanelShow = 'never';
  public readonly pivotPanelShow = 'always';
  public readonly rowSelection = 'multiple';
  public readonly undoRedoCellEditing = true;
  public readonly undoRedoCellEditingLimit = 4;
  public readonly enableCellChangeFlash = true;
  public readonly overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait...</span>';
  public pinnedTopRowData: any[] = [];
  public readonly sideBar = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
        }
      },
      // https://www.ag-grid.com/angular-data-grid/component-tool-panel/
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
        toolPanelParams: {
          suppressExpandAll: false,
          suppressFilterSearch: false
        }
      },
      // {
      //   id: 'feedsPanel',
      //   labelDefault: 'Feeds',
      //   labelKey: 'customStats',
      //   iconKey: 'pivotPanel',
      //   toolPanel: FeedToolPanelComponent,
      // },
    ],
  };

  public readonly autoGroupColumnDef: ColDef = {
    minWidth: 200,
  }
  public rowClassRules: RowClassRules = {
    'not-valid': (params) => {
      if (params.data && (!params.data.handle || !params.data.brand)) {
        return true
      } else {
        return false;
      }
    },
    'sync-in-progress': (params) => {
      if (params.data) {
        return params.data.shopify_sync_status === 2;
      } else {
        return false;
      }
    },
    'confirm-changes': (params) => {
      return !!(params.data && params.data.status === 30);
    },
    // 'import-product': (params) => {
    //   // return !!(params.data && params.data.new);
    //   return !!(params.data);
    // },
    'product-change-icon' : (params) => {
      // return !!(params.data && [20, 30, 40].includes(params.data.status) && !params.data.new);
      return !!(params.data && [20, 30, 40].includes(params.data.status));
    },
    'editing-row': (params) => {
      if (params.data && params.data.locked && params.data.locked.user && (params.data.locked.user._id !== this.authService.currentUserValue._id)) {
        return true;
      } else {
        return false;
      }
    },
  };
  public readonly statusBar = {
    statusPanels: [
      { statusPanel: 'agSelectedRowCountComponent' }
    ],
  };

  public columnDefs: ColDef[] = this.sharedService.columnDefs;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 170,
    sortable: true,
    editable: true,
    filter: true,
    resizable: true,

    cellRenderer: (cell: any) => {
      // console.log(cell, cell.colDef.field);
      if (!['tags'].includes(cell.colDef.field)) {
        return cell.value;
      }
    },

    cellClass: (params: any) => {
      // console.log('params', params);
      const cellChanged = params.data?.fields_status?.[params.colDef.field] === 20;
      const cellLock = params.data.locked !== undefined && Object.keys(params.data.locked).length > 0;
      const cellLockOtherUsers = cellLock ? params.data.locked && params.data.locked.user && params.data.locked.user._id !== this.authService.currentUserValue?._id: false;
      const cellLockCurrentUsers = cellLock ? params.data.locked && params.data.locked.user && params.data.locked.user._id === this.authService.currentUserValue._id: false;
      const cellPrice = (params.colDef.field === 'list_price' || params.colDef.field === 'cost_price'  || params.colDef.field === 'sell_price' || params.colDef.field === 'mws_sell_price');

      // if (cellPrice && cellChanged && params.data.new !== true) {
      if (cellPrice && cellChanged) {
        return ['number-cell', 'ag-cell-changed'];
        // } else if (cellChanged && params.data.new !== true) {
      } else if (cellChanged) {
        if (cellLockOtherUsers) {
          return '';
        }
        return 'ag-cell-changed';
      } else if (params.colDef.field === 'sku') {
        return 'sku-col';
      } else if (cellPrice) {
        return 'number-cell';
      }

      return '';
    }
  };
  public rowData$!: Observable<any[]>;

  constructor(
    private sharedService: SharedService,
    private gridService: GridService,
    private localStorageService: LocalStorageService,
    private authService: AuthService,
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    // this.rowData$ = this.httpService.post(environment.API_PATH + '/product/bad', {startRow: 0, endRow: 10000});
  }

  onGridReady(params: GridReadyEvent) {
    this.gridService.gridApi = params.api;
    this.gridService.columnApi = params.columnApi;
    const that = this;
    // setTimeout(() => {
    //   const prevFilterModel = this.localStorageService.getItem('stageFilterModel');
    //   this.gridService.gridApi?.setFilterModel(prevFilterModel);
    // }, 10);
    this.gridService.gridApi.setServerSideDatasource({
      getRows(params: IServerSideGetRowsParams) {
        const {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel} = params.request;

        const body = {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel};
        that.httpService.post(environment.API_PATH + '/product/bad', body).subscribe((dataAndCount) => {
          const receivedData = dataAndCount as { rows: {}[], count: number };
          params.success({
            rowData: receivedData.rows,
            rowCount: receivedData.count
          });
        });
      }
    });
  }

  onSelectionChanged($event: any): void {}
  onCellClicked($event: any): void {}
  cellEditingStarted($event: any): void {}
  cellValueChanged($event: any): void {}
  cellEditingStopped($event: any): void {}
  cellEditRequest($event: any): void {}
  filterChanged($event: any): void {}

  getContextMenuItems = (params: GetContextMenuItemsParams) => {
    return [];
  }
}
